module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/de/saskia-629007b5f0a5ba7727425e47a6f62933.jpg";